webpackJsonp([31],{

/***/ "4pw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseVideoCard_vue__ = __webpack_require__("PS0Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c083ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseVideoCard_vue__ = __webpack_require__("oN9l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("mUgZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2c083ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseVideoCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c083ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseVideoCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c083ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseVideoCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FNvz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseVideo_vue__ = __webpack_require__("bx6W");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0205b62_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseVideo_vue__ = __webpack_require__("HuFY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("hkuU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0205b62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0205b62_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseVideo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0205b62_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseVideo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HuFY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-supplement-no-title-layout"},[_c('div',{staticClass:"layout-content course-video"},[_c('div',{staticClass:"header"},[_c('p',{staticClass:"video-sum"},[_vm._v("共有视频回放: "+_vm._s(_vm.playbackInfo.total || 0))]),_vm._v(" "),_c('el-select',{staticClass:"selector",attrs:{"placeholder":"请选择"},on:{"change":_vm.onChangeSelect},model:{value:(_vm.filterType),callback:function ($$v) {_vm.filterType=$$v},expression:"filterType"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_vm._l((_vm.currentPlaybacksByRow),function(arr,index){return _c('div',{key:index,staticClass:"card-list"},_vm._l((arr),function(item,index){return _c('VideoCard',{key:item.sessionId,attrs:{"item":item,"is-middle":index === 1}})}))}),_vm._v(" "),_c('div',{staticClass:"playback-pagination"},[(_vm.showPagination)?_c('el-pagination',{staticClass:"handler",attrs:{"page-size":_vm.pageSize,"current-page":_vm.currentPage,"layout":"prev, pager, next","total":_vm.playbackInfo.total},on:{"update:currentPage":function($event){_vm.currentPage=$event},"current-change":_vm.onPageChange}}):_vm._e()],1)],2)])}
var staticRenderFns = []


/***/ }),

/***/ "PS0Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Enums) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_user_user_info_png__ = __webpack_require__("+JQD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_user_user_info_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_user_user_info_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {}
        },
        isMiddle: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            defaultAvatar: __WEBPACK_IMPORTED_MODULE_0__assets_images_user_user_info_png___default.a,
            showLessonImage: true
        };
    },

    methods: {
        // 跳转回放详情
        viewPlayback: function viewPlayback(playback) {
            var lessonId = playback.lessonId,
                coursePlanId = playback.coursePlanId,
                sessionId = playback.sessionId,
                type = playback.type;

            this.$router.push({ name: 'videoDetail@course',
                query: {
                    lessonId: lessonId, coursePlanId: coursePlanId, sessionId: sessionId, type: type
                } });
        },

        // 确定所需的css class；
        getTypeTagClass: function getTypeTagClass(type) {
            switch (type) {
                case Enums.LessonType.FREE_LESSON:
                    return 'type-tag-free';
                case Enums.LessonType.FORMAL_LESSON:
                    return 'type-tag-formal';
                case Enums.LessonType.QA_LESSON:
                    return 'type-tag-qa';
                default:
                    return '';
            }
        },

        // 跳转“课后报告”
        viewReport: function viewReport(playback) {
            var VIDEO_NOT_GENERATED = 1;
            if (playback.reportGenerated === VIDEO_NOT_GENERATED) {
                return;
            }
            var lessonId = playback.lessonId,
                coursePlanId = playback.coursePlanId,
                type = playback.type;

            this.$router.push({
                name: 'report@course',
                query: { lessonId: lessonId, coursePlanId: coursePlanId, type: type }
            });
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vvAD")))

/***/ }),

/***/ "bx6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Enums) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("y7q8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("ewS8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CourseVideoCard__ = __webpack_require__("4pw7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { VideoCard: __WEBPACK_IMPORTED_MODULE_2__CourseVideoCard__["a" /* default */] },
    data: function data() {
        return {
            playbackInfo: {
                total: 0,
                playbacks: []
            },
            filterType: 0,
            options: [{
                value: 0,
                label: '全部'
            }, {
                value: Enums.LessonType.FREE_LESSON,
                label: '试听课'
            }, {
                value: Enums.LessonType.FORMAL_LESSON,
                label: '正式课'
            }, {
                value: Enums.LessonType.QA_LESSON,
                label: '答疑课'
            }],
            // 分页
            currentPage: 1,
            pageSize: 9

        };
    },

    computed: {
        showPagination: function showPagination() {
            return this.playbackInfo.total / this.pageSize > 1;
        },
        currentPlaybacksByRow: function currentPlaybacksByRow() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.chunk(this.playbackInfo.playbacks, 3);
        }
    },
    beforeMount: function beforeMount() {
        this.getPlaybackInfo({ limit: this.pageSize });
    },

    methods: {
        /**
         * 获取回放列表
         * @params: params: API调用涉及到的数据：
         * {
         *      types: '1,2',   // 【可选】课程类型 enum#LessonType;如果没有该字段则认为筛选所有课程类型;字符串，如果为多个类型用英文逗号分隔
                start: 0,       // 【可选】翻页开始条目 默认0
                limit: 10,      // 【可选】每页数目 默认10
            }
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=80543837#hfsfd-be%E5%9B%9E%E6%94%BE%EF%BC%88%E8%BF%9E%E7%BA%BF%EF%BC%89API-%E8%8E%B7%E5%8F%96%E5%9B%9E%E6%94%BE%E5%88%97%E8%A1%A8%E3%80%90WIP%E3%80%91
         */
        fetchPlaybackInfo: function fetchPlaybackInfo(params) {
            var _this = this;

            return this.$http.get('/v1/playbacks/list', { params: params }).then(function (resp) {
                return _this.$checkResp(resp, null);
            });
        },

        getPlaybackInfo: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (params) {
            var _this2 = this;

            this.fetchPlaybackInfo(params).then(function (data) {
                _this2.handlePlaybackInfo(data);
            }).catch(function (err) {
                _this2.$handleError(err);
            });
        }, 20),
        // 对API返回的数据预处理
        handlePlaybackInfo: function handlePlaybackInfo(data) {
            if (data) {
                data.playbacks.forEach(function (item) {
                    var startTimeStr = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.startTime).format('YYYY-MM-DD HH:mm');
                    var endTimeStr = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.endTime).format('HH:mm');
                    item.periodStr = '\u4E0A\u8BFE\u65F6\u95F4\uFF1A ' + startTimeStr + ' ~ ' + endTimeStr;

                    switch (item.type) {
                        case Enums.LessonType.FREE_LESSON:
                            item.typeStr = '试听';
                            break;
                        case Enums.LessonType.FORMAL_LESSON:
                            item.typeStr = '正式';
                            break;
                        case Enums.LessonType.QA_LESSON:
                            item.typeStr = '答疑';
                            break;
                    }
                });
            } else {
                data = {
                    total: 0,
                    playbacks: []
                };
            }
            this.playbackInfo = data;
        },

        // 分页跳转处理函数
        onPageChange: function onPageChange(currentPage) {
            this.currentPage = currentPage;
            var params = {
                start: (currentPage - 1) * this.pageSize,
                limit: this.pageSize
            };
            // 除非是 0 （全部types），否则需要设置types
            if (this.filterType) {
                params.types = this.filterType;
            }
            this.getPlaybackInfo(params);
        },

        // 下拉菜单变更处理函数
        onChangeSelect: function onChangeSelect(type) {
            this.filterType = type;
            this.currentPage = 1;
            var params = {
                start: 0,
                limit: this.pageSize
            };
            // 除非是 0 （表示全部types），否则需要设置types
            if (this.filterType) {
                params.types = this.filterType;
            }
            this.getPlaybackInfo(params);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("vvAD")))

/***/ }),

/***/ "hkuU":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("n8y0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("56b0cd5a", content, true, {});

/***/ }),

/***/ "kW46":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".card[data-v-b2c083ec]{width:290px;height:207px;background-color:#fff;margin:7.5px 0;-webkit-box-shadow:0 0 8px 0 #cdd0d4;box-shadow:0 0 8px 0 #cdd0d4;border-radius:2px;cursor:pointer}.card[data-v-b2c083ec]:hover{-webkit-box-shadow:0 0 20px 0 #cdd0d4;box-shadow:0 0 20px 0 #cdd0d4}.card .lesson-img[data-v-b2c083ec]{width:100%;height:163px;background:#f2f2f2;position:relative}.card .lesson-img img[data-v-b2c083ec]{width:100%;height:163px}.card .period[data-v-b2c083ec]{background-image:-webkit-gradient(linear,left top,left bottom,from(transparent),to(rgba(0,0,0,.6)));background-image:linear-gradient(-180deg,transparent,rgba(0,0,0,.6));height:30px;line-height:30px;position:absolute;bottom:0;left:0;right:0;font-size:12px;color:#fff;padding-left:6px}.card .info[data-v-b2c083ec]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:44px;padding:0 6px}.card .info .avatar[data-v-b2c083ec]{width:24px;height:24px;border-radius:50%;vertical-align:middle}.card .info .family-name[data-v-b2c083ec]{padding:0 6px}.card .info .type-tag[data-v-b2c083ec]{line-height:1.5;font-size:12px;display:inline-block;padding:0 4px;background:rgba(145,113,221,.1);border-radius:0 8px}.card .info .type-tag-formal[data-v-b2c083ec]{background:rgba(45,189,114,.1);color:#2dbd72}.card .info .type-tag-qa[data-v-b2c083ec]{background:rgba(255,132,83,.1);color:#ff8453}.card .info .type-tag-free[data-v-b2c083ec]{background:rgba(145,113,221,.1);color:#9171dd}.card .info .report-ready[data-v-b2c083ec]{color:#1daef8;cursor:pointer}.card .info .report-ready[data-v-b2c083ec]:hover{color:#0683c2}.card .info .report-disable[data-v-b2c083ec]{color:#9fa3ad;cursor:text}.middle-card[data-v-b2c083ec]{margin:7.5px 25px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/views/index/components/CourseVideoCard.vue"],"names":[],"mappings":"AAGA,uBACE,YAAa,AACb,aAAc,AACd,sBAAuB,AACvB,eAAgB,AAChB,qCAAsC,AAC9B,6BAA8B,AACtC,kBAAmB,AACnB,cAAgB,CACjB,AACD,6BACI,sCAAuC,AAC/B,6BAA+B,CAC1C,AACD,mCACI,WAAY,AACZ,aAAc,AACd,mBAAoB,AACpB,iBAAmB,CACtB,AACD,uCACM,WAAY,AACZ,YAAc,CACnB,AACD,+BACI,oGAAkH,AAClH,qEAAyF,AACzF,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,QAAS,AACT,eAAgB,AAChB,WAAY,AACZ,gBAAkB,CACrB,AACD,6BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,YAAa,AACb,aAAe,CAClB,AACD,qCACM,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,qBAAuB,CAC5B,AACD,0CACM,aAAe,CACpB,AACD,uCACM,gBAAiB,AACjB,eAAgB,AAChB,qBAAsB,AACtB,cAAe,AACf,gCAAqC,AACrC,mBAAqB,CAC1B,AACD,8CACM,+BAAoC,AACpC,aAAe,CACpB,AACD,0CACM,+BAAoC,AACpC,aAAe,CACpB,AACD,4CACM,gCAAqC,AACrC,aAAe,CACpB,AACD,2CACM,cAAe,AACf,cAAgB,CACrB,AACD,iDACQ,aAAe,CACtB,AACD,6CACM,cAAe,AACf,WAAa,CAClB,AACD,8BACE,iBAAmB,CACpB","file":"CourseVideoCard.vue","sourcesContent":["\n@charset \"UTF-8\";\n/*颜色库*/\n.card[data-v-b2c083ec] {\n  width: 290px;\n  height: 207px;\n  background-color: #fff;\n  margin: 7.5px 0;\n  -webkit-box-shadow: 0 0 8px 0 #cdd0d4;\n          box-shadow: 0 0 8px 0 #cdd0d4;\n  border-radius: 2px;\n  cursor: pointer;\n}\n.card[data-v-b2c083ec]:hover {\n    -webkit-box-shadow: 0 0 20px 0 #cdd0d4;\n            box-shadow: 0 0 20px 0 #cdd0d4;\n}\n.card .lesson-img[data-v-b2c083ec] {\n    width: 100%;\n    height: 163px;\n    background: #f2f2f2;\n    position: relative;\n}\n.card .lesson-img img[data-v-b2c083ec] {\n      width: 100%;\n      height: 163px;\n}\n.card .period[data-v-b2c083ec] {\n    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.6)));\n    background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);\n    height: 30px;\n    line-height: 30px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    font-size: 12px;\n    color: #fff;\n    padding-left: 6px;\n}\n.card .info[data-v-b2c083ec] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: 44px;\n    padding: 0 6px;\n}\n.card .info .avatar[data-v-b2c083ec] {\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      vertical-align: middle;\n}\n.card .info .family-name[data-v-b2c083ec] {\n      padding: 0 6px;\n}\n.card .info .type-tag[data-v-b2c083ec] {\n      line-height: 1.5;\n      font-size: 12px;\n      display: inline-block;\n      padding: 0 4px;\n      background: rgba(145, 113, 221, 0.1);\n      border-radius: 0 8px;\n}\n.card .info .type-tag-formal[data-v-b2c083ec] {\n      background: rgba(45, 189, 114, 0.1);\n      color: #2dbd72;\n}\n.card .info .type-tag-qa[data-v-b2c083ec] {\n      background: rgba(255, 132, 83, 0.1);\n      color: #ff8453;\n}\n.card .info .type-tag-free[data-v-b2c083ec] {\n      background: rgba(145, 113, 221, 0.1);\n      color: #9171dd;\n}\n.card .info .report-ready[data-v-b2c083ec] {\n      color: #1daef8;\n      cursor: pointer;\n}\n.card .info .report-ready[data-v-b2c083ec]:hover {\n        color: #0683c2;\n}\n.card .info .report-disable[data-v-b2c083ec] {\n      color: #9fa3ad;\n      cursor: text;\n}\n.middle-card[data-v-b2c083ec] {\n  margin: 7.5px 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "mUgZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kW46");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("rjj0").default
var update = add("1c11c994", content, true, {});

/***/ }),

/***/ "n8y0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".course-video[data-v-b0205b62]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.header[data-v-b0205b62]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:12.5px}.header .video-sum[data-v-b0205b62]{font-size:16px;color:#333}.header .selector[data-v-b0205b62]{border-radius:2px;width:120px;height:36px}.card-list[data-v-b0205b62],.playback-pagination[data-v-b0205b62]{display:-webkit-box;display:-ms-flexbox;display:flex}.playback-pagination[data-v-b0205b62]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:1;-ms-flex:1;flex:1}.playback-pagination .handler[data-v-b0205b62]{margin:17px 0 0;-ms-flex-item-align:end;align-self:flex-end}", "", {"version":3,"sources":["/home/work/jenkins/workspace/FD-FE_hfsfd-student/src/views/index/components/CourseVideo.vue"],"names":[],"mappings":"AAGA,+BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,yBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAsB,CACvB,AACD,oCACI,eAAgB,AAChB,UAAY,CACf,AACD,mCACI,kBAAmB,AACnB,YAAa,AACb,WAAa,CAChB,AAMD,kEAJE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAYf,AAVD,sCAIE,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AAChB,WAAY,AACR,MAAQ,CACjB,AACD,+CACI,gBAAiB,AACjB,wBAAyB,AACrB,mBAAqB,CAC5B","file":"CourseVideo.vue","sourcesContent":["\n@charset \"UTF-8\";\n/*颜色库*/\n.course-video[data-v-b0205b62] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.header[data-v-b0205b62] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 12.5px;\n}\n.header .video-sum[data-v-b0205b62] {\n    font-size: 16px;\n    color: #333;\n}\n.header .selector[data-v-b0205b62] {\n    border-radius: 2px;\n    width: 120px;\n    height: 36px;\n}\n.card-list[data-v-b0205b62] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.playback-pagination[data-v-b0205b62] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.playback-pagination .handler[data-v-b0205b62] {\n    margin: 17px 0 0;\n    -ms-flex-item-align: end;\n        align-self: flex-end;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "oN9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:_vm.isMiddle ? 'middle-card' : '',on:{"click":function($event){_vm.viewPlayback(_vm.item)}}},[_c('div',{staticClass:"lesson-img"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLessonImage),expression:"showLessonImage"}],attrs:{"src":_vm.item.imageUrl},on:{"error":function($event){_vm.showLessonImage = false}}}),_vm._v(" "),_c('div',{staticClass:"period"},[_vm._v(" "+_vm._s(_vm.item.periodStr))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',[_c('img',{staticClass:"avatar",attrs:{"src":_vm.item.teacherAvatar || _vm.defaultAvatar,"alt":"👱"}}),_vm._v(" "),_c('span',{staticClass:"family-name"},[_vm._v(_vm._s(_vm.item.teacherFamilyName)+"老师")]),_vm._v(" "),_c('span',{staticClass:"type-tag",class:_vm.getTypeTagClass(_vm.item.type)},[_vm._v(_vm._s(_vm.item.typeStr))])])])])}
var staticRenderFns = []


/***/ })

});


// WEBPACK FOOTER //
// static/js/31.1e2b111268520ce13366.js